import MethodComponent from './MethodComponent'

class ConstructorComponent extends MethodComponent {}

export default ConstructorComponent
